import { Amount, Loan } from "./DealContext";

//   // for (const dataChunk of streamingData) {
//   //   await new Promise((resolve) => setTimeout(resolve, 1000));
//   //   updateLoan(loanId, dataChunk);
//   // }
// };
const amountMock: Amount = {
  amount: {
    value: null,
    chunk: {
      chunk: "",
    },
  },
  currency: {
    value: "EUR",
    chunk: {
      chunk: "",
    },
  },
};

export const loanMock: Loan = {
  id: "string",
  documentUrl: "string",
  documentType: "pdf",
  name: "",
  description: "",
  financed_boat_number: 0,
  type: undefined,
  vessels: {
    value: [],
    chunk: {
      chunk: "",
    },
  },
  contacts: {
    value: [],
    chunk: {
      chunk: "",
    },
  },
  amount: amountMock,
  borrower: {
    value: null,
    chunk: {
      chunk: "",
    },
  },
  agent: {
    value: null,
    chunk: {
      chunk: "",
    },
  },
  guarantors: {
    value: [],
    chunk: {
      chunk: "",
    },
  },
  margin: {
    value: null,
    chunk: {
      chunk: "",
    },
  },
  maturity_date: {
    value: {
      rule: "",
      maturity_date: undefined,
    },
    chunk: {
      chunk: "",
    },
  },
  banking_syndicate: {
    value: [],
    chunk: {
      chunk: "",
    },
  },
};
export default {};
